import { useCurrentUser } from '@ianesthesie-kit/redux';
import { Patient } from './userConfig.model';

export const useCurrentPatient = () => useCurrentUser() as Patient | undefined;
